import { render, staticRenderFns } from "./MatchFields.vue?vue&type=template&id=4a4867e9&"
import script from "./MatchFields.vue?vue&type=script&lang=ts&"
export * from "./MatchFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports